import { FormSection } from '@/shared/lib/forms/form-wrapper.types';
import { BirthCertificateFormSections } from '@/shared/lib/forms/personal-IDs/birthCertificate';
import { CitizenshipCertificateFormSections } from '@/shared/lib/forms/personal-IDs/citizenshipCertificate';
import { DriverLicenseFormSections } from '@/shared/lib/forms/personal-IDs/driverLicense';
import { EducationFormSections } from '@/shared/lib/forms/personal-IDs/education';
import { FreeBlockSections } from '@/shared/lib/forms/personal-IDs/freeBlock';
import { InternationalDriverLicenseFormSections } from '@/shared/lib/forms/personal-IDs/internationalDriverLicense';
import { MedicalFormSections } from '@/shared/lib/forms/personal-IDs/medical';
import { MilitaryIDFormSections } from '@/shared/lib/forms/personal-IDs/militaryID';
import { NationalIdFormSections } from '@/shared/lib/forms/personal-IDs/nationalID';
import { PassportFormSections } from '@/shared/lib/forms/personal-IDs/passport';
import { ResidencePermitFormSections } from '@/shared/lib/forms/personal-IDs/residencePermit';
import { SocialSecurityFormSections } from '@/shared/lib/forms/personal-IDs/socialSecurity';
import { SubstanceSections } from '@/shared/lib/forms/personal-IDs/substance';
import { TaxIDFormSections } from '@/shared/lib/forms/personal-IDs/taxID';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm/models/personalIdentifiersDocuments/types';

export const getPersonalIdentifierForms = (
  type: PersonalIdentifierType,
): Array<FormSection> | null => {
  const forms = {
    [PersonalIdentifierType.CITIZENSHIP_CERTIFICATE]: CitizenshipCertificateFormSections,
    [PersonalIdentifierType.PASSPORT]: PassportFormSections,
    [PersonalIdentifierType.NATIONAL_ID]: NationalIdFormSections,
    [PersonalIdentifierType.BIRTH_CERTIFICATE]: BirthCertificateFormSections,
    [PersonalIdentifierType.DRIVER_LICENSE]: DriverLicenseFormSections,
    [PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE]: InternationalDriverLicenseFormSections,
    [PersonalIdentifierType.RESIDENCE_PERMIT]: ResidencePermitFormSections,
    [PersonalIdentifierType.TAX_ID]: TaxIDFormSections,
    [PersonalIdentifierType.EDUCATION]: EducationFormSections,
    [PersonalIdentifierType.MEDICAL_ID]: MedicalFormSections,
    [PersonalIdentifierType.SOCIAL_SECURITY]: SocialSecurityFormSections,
    [PersonalIdentifierType.MILITARY_ID]: MilitaryIDFormSections,
    [PersonalIdentifierType.FREE_BLOCK]: FreeBlockSections,
    [PersonalIdentifierType.SUBSTANCE]: SubstanceSections,
  } as Partial<Record<PersonalIdentifierType, Array<FormSection>>>;

  return forms[type] ?? null;
};
